var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"none"},[_c('div',{staticClass:"content"},[_c('div',[_vm._v("访问页面不存在，将在3s后返回上一级")]),_c('el-button',{staticClass:"ml-20",on:{"click":_vm.goBack}},[_vm._v("返回上一级")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }